// This file was automatically generated from providerPassportLeadGen.html.
// Please don't edit this file by hand.

goog.provide('el8.template.marketing.providerPassportLeadGen');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.marketing.providerPassportLeadGen.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div id="tourguide-splash"><div id="tourguide-splash-info" class="tourGuideSplashDialog"><div class="tourGuideDialogContainer"></div></div><div id="tourguide-splash-overlay" class="tourGuideSplash"></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.marketing.providerPassportLeadGen.leadGenFloater = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<h2 style="padding-bottom:10px;color:#fff;border-bottom:1px solid #1a6a8a;box-shadow:0px 1px 0px rgba(255,255,255, 0.3)" >', (opt_data.role == 'clinician') ? 'Was this easy enough?' : 'Was this easy enough?', '</h2><div class="tourGuideTextContainerSm"><p style="padding:10px 0;text-align:center;border:1px solid #1a6a8a;font-size:1.4em;margin-bottom:20px;" class="el8FFF">Elation is a fully functional and Meaningful Use 2014 Certified EMR</p><p class="el8FFF" style="font-size: 1.6em;">Elation Health can streamline your day-to-day clinical tasks and help you continue taking good care of your patients.</p><p class="el8FFF" style="font-size: 1.6em;">Let’s take a moment to go over the platform together. Simply click below and we’ll get back to you to schedule a demo of the full product.</p><div id="lead-gen-buttons" class="tourSplashButtonContainer" style="text-align:right;"><a id="no-demo-button" class="start-trigger" style="font-size:1.2em;color: #f1f1f1;text-decoration:underline;">Not interested</a><a id="demo-button" class="start-trigger tourGuideButton" style="margin-left:15px;">Contact me to schedule a demo</a></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.marketing.providerPassportLeadGen.leadGenDemoConfirmFloater = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<h2>Thank you.  We will be contacting you shortly.</h2>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.marketing.providerPassportLeadGen.leadGenNoDemoReason = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<p class="el8FFF">Would you tell us why?</p><input type="text" id="no-demo-reason-input"></input><div class="tourSplashButtonContainer"><a id="no-demo-reason-submit" class="start-trigger tourGuideButton">Submit</a></div>');
  if (!opt_sb) return output.toString();
};
